import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { createOrderLifetimeEpic } from './_epics/createOrderLifetime.epic';
import { updateOrderLifetimeEpic } from './_epics/updateOrderLifetime.epic';
import { removeOrderLifetimeEpic } from './_epics/removeOrderLifetime.epic';
import { loadOrderLifetimeEpic } from './_epics/loadOrderLifetime.epic';
import { exportOrderLifetimeEpic } from './_epics/exportOrderLifetime.epic';

export const orderLifetimeEpic = safeCombineEpics(
  createOrderLifetimeEpic,
  updateOrderLifetimeEpic,
  removeOrderLifetimeEpic,
  loadOrderLifetimeEpic,
  exportOrderLifetimeEpic,
);
